module.exports = __webpack_public_path__ + "static/media/colourOptions6.d8939fe0.JPG";